export default "__VITE_ASSET__CoMDdePN__"